import { Book } from "./types";
export const last = (a: any[]): any | undefined => {
  if (a.length > 0) return a[a.length - 1];
  return undefined;
};
export const areAnyBooks = (bs: Object) => {
  return Object.keys(bs).length > 0;
};
export const isFinished = (book: Book): boolean => {
  const rs = book.readingSessions;
  const lastRs = last(rs);
  if (lastRs) return lastRs.page_finish === book.pages;
  return false;
};
export const getPercentage = (book: Book) => {
  const rs = book.readingSessions;
  const lastRs = last(rs);
  if (lastRs) return (lastRs.page_finish / book.pages) * 100;
  return 0;
};

export function iOS() {
  return (
    [
      "iPad Simulator",
      "iPhone Simulator",
      "iPod Simulator",
      "iPad",
      "iPhone",
      "iPod",
    ].includes(navigator.platform) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  );
}
